import React from "react";
import "./Licenses.css";

import { NavLink } from "react-router-dom";

class Licenses extends React.Component {
  render() {
    return (
      <main className="box">
        <div className="backMenuBox">
          <NavLink to="/profile">
            <img src="/images/back.png" />
          </NavLink>

          <h1>About</h1>
        </div>

        <section className="licenseBox">
          <div className="aboutBox">
            <div className="aboutTopBox">
              <img src="/images/dev.png" />
              <p>Luís Mártires</p>
            </div>

            <div className="socialsBox">
              <a href="https://www.linkedin.com/in/luismartires/"><img src="/images/linkedin.png" /></a>
              <a href="https://github.com/luismartires"><img src="/images/github.png" /></a>
            </div>

            <div className="aboutBotBox">
            <h2>About AutoRepair</h2>
              <p>
                This project is a Web Application using the MERN full stack
                (MongoDB, Express, React and Node.js). UX and Agile
                methodologies for the planning, with Trello. React for all the
                user-facing parts of the application. Express for the API
                backend which React app is communicating with. Mongoose for
                models and database communication.
              </p>
               <img src="/images/ironhack.png" />
            </div>

           
       
          </div>
        </section>
      </main>
    );
  }
}
export default Licenses;
